/**
 * This wrapper can store js serializable objects in localStorage (based on JSON);
 * try/catch on every getItem call may slightly down performance, be careful if you reading from localStorage often.
 */
export default {
  getItem(key) {
    const value = localStorage.getItem(key);
    //if it's json string, return parsed js object, otherwise return result as is
    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  },
  setItem(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  },
  removeItem(key) {
    localStorage.removeItem(key);
  },
};
